// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");

function parenCntMake(parentheses, checkParensOptimizedOpt) {
  var checkParensOptimized = checkParensOptimizedOpt !== undefined ? checkParensOptimizedOpt : true;
  var parenLen = parentheses.length;
  if (parenLen % 2 !== 0) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "mod(parenLen, 2)  != 0 in parenCntMake"
          },
          Error: new Error()
        };
  }
  if (parenLen === 0) {
    return {
            min: 0,
            parens: [],
            parentStack: [],
            failed: false
          };
  }
  var parens = [];
  var maxI = (parenLen / 2 | 0) - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var openCode = parentheses[(i << 1)];
    var closeCode = parentheses[(i << 1) + 1 | 0];
    parens.push({
          code: openCode,
          isOpen: true,
          opposite: closeCode
        });
    parens.push({
          code: closeCode,
          isOpen: false,
          opposite: openCode
        });
  }
  var min = Core__Array.reduce(parentheses, parentheses[0], (function (min, p) {
          if (min <= p) {
            return min;
          } else {
            return p;
          }
        }));
  if (checkParensOptimized && Math.abs(min) !== parenLen) {
    console.log("Warning: parentheses are not optimized (this may slow down the unification process).");
  }
  return {
          min: min,
          parens: parens,
          parentStack: [],
          failed: false
        };
}

function parenCntReset(cnt) {
  Expln_utils_common.clearArray(cnt.parentStack);
  cnt.failed = false;
}

function parenCntPut(cnt, i) {
  if (!cnt.failed && cnt.min <= i && i < 0) {
    var paren = cnt.parens.find(function (param) {
          return param.code === i;
        });
    if (paren !== undefined) {
      if (paren.isOpen) {
        cnt.parentStack.push(paren);
      } else {
        var lastParen = cnt.parentStack.pop();
        if (lastParen !== undefined && lastParen.opposite === paren.code) {
          
        } else {
          cnt.failed = true;
        }
      }
    }
    
  }
  if (cnt.failed) {
    return "Failed";
  } else if (cnt.parentStack.length === 0) {
    return "Balanced";
  } else {
    return "Opened";
  }
}

exports.parenCntMake = parenCntMake;
exports.parenCntReset = parenCntReset;
exports.parenCntPut = parenCntPut;
/* Common Not a pure module */
